import { FC } from 'react';

import ProProfileDetails from './ProProfileDetails';
import styles from './ProProfile.module.scss';

import { ProProfilePro } from '../types';
import type { BlogPost } from 'modules/marketing-pages/marketing-page.types';

interface Props {
  featureFlags: { isReviewsQAEnabled: boolean };
  internalBlogPosts: Array<BlogPost>;
  internalBlogCostPosts: Array<BlogPost>;
  jobTypeId?: string;
  pro: ProProfilePro;
  setJobTypeTitle: (jobTypeId: string) => void;
}

const ProProfile: FC<Props> = ({
  pro,
  featureFlags,
  internalBlogPosts,
  internalBlogCostPosts,
  jobTypeId,
  setJobTypeTitle,
}) => (
  <>
    <div className={styles['pro-profile-content-wrapper']}>
      <ProProfileDetails
        featureFlags={featureFlags}
        internalBlogPosts={internalBlogPosts}
        internalBlogCostPosts={internalBlogCostPosts}
        jobTypeId={jobTypeId}
        user={pro}
        setJobTypeTitle={setJobTypeTitle}
      />
    </div>
  </>
);

export default ProProfile;
